import { CustomFieldValue } from '@xiag-search/sdk';
import { parseDate } from 'src/utils/parseDate';

export function getCustomFieldDate(value: CustomFieldValue | null): Date | null {
    if (typeof value !== 'string') {
        return null;
    }

    return parseDate(value);
}
